import { IconButton } from '@mui/material';
import React from 'react';

import { ReactComponent as CloseIcon } from '../../../../../../assets/icons/close.svg';
import { ConversationMessage } from '../../../../../../types/chat';
import ReplyMessageBubble from '../ReplyMessage';
import {
    CloseButtonWrapper,
    ReplyingBubble,
    ReplyingContainer,
    ReplyingHeader,
    ReplyingOwner } from './styled';

type Props = {
    message: ConversationMessage;
    onCancel: () => void;
};

const ReplyComposer: React.FC<Props> = ({ message, onCancel }) => {
    return (
        <ReplyingContainer>
            <ReplyingHeader>Replying to message</ReplyingHeader>
            <ReplyingBubble>
                <ReplyingOwner>
                    {message.isOwn ? 'me' : message.senderAlias || 'Unknown'}
                </ReplyingOwner>
                <ReplyMessageBubble
                    replyMessage={message}
                    sentByMe={message.isOwn}
                />
                <CloseButtonWrapper>
                    <IconButton size="small" onClick={onCancel}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </CloseButtonWrapper>
            </ReplyingBubble>
        </ReplyingContainer>
    );
};

export default ReplyComposer;
